export class ViveApiError extends Error {
  public httpStatusCode?: number;

  public constructor(
    message: string,
    options?: { httpStatusCode?: number; cause?: unknown }
  ) {
    super(message, options);
    this.httpStatusCode = options?.httpStatusCode;
  }
}
